<template>
  <div v-if="show" ref="modalOnboardingRef" class="mc-modal__reminder text">
    <div class="w-100 d-flex justify-content-end">
      <i
        class="icon-outline_close font-size-20 align-middle mc-pointer__reminder"
        @click="closeModal"
      >
      </i>
    </div>
    <div class="text-center">
      <img
        :src="illustrationPath"
        alt
        class="avatar-lg img-thumbnail mb-3 mc-object-cover__reminder"
      />
      <h5 class="mb-2">
        {{ title }}
      </h5>
      <p class="mb-3 text-muted font-size-12">
        {{ description }}
      </p>
      <b-button variant="primary" class="small w-100 p-1 mb-2" size="sm" @click="navigateTo">
        {{ buttonText }}
      </b-button>
      <b-button
        variant="outline-primary"
        class="small w-100 p-1 mc-outline-none__reminder"
        size="sm"
        @click="remindLater"
      >
        {{ $t('notification.reminder.later') }}
      </b-button>
    </div>
  </div>
</template>
<script>
import { Helper } from '@/mixin/helper'
import { patchProfile } from '@/services/rest-api-vsms/lib/profile/profile'

export default {
  mixins: [Helper],
  data() {
    return {
      show: false,
    }
  },
  computed: {
    illustrationPath() {
      if (!this.profile.email)
        return require('@/assets/images/illustration/whitelabel/verification_email.png')
      else return require('@/assets/images/illustration/whitelabel/verification_phone.png')
    },
    profile() {
      return this.$store.state.access.profile
    },
    title() {
      if (!this.profile.email) return this.$t('notification.reminder.emailTitle')
      else return this.$t('notification.reminder.numberTitle')
    },
    description() {
      if (!this.profile.email) return this.$t('notification.reminder.emailDesc')
      else return this.$t('notification.reminder.numberDesc')
    },
    buttonText() {
      if (!this.profile.email) return this.$t('notification.reminder.addEmail')
      else return this.$t('notification.reminder.addNumber')
    },
    isLastReminderInCurrentMonth() {
      if (!this.profile.lastReminder) return false
      const lastReminder = this.profile.lastReminder
      const now = new Date();
      const lastReminderDate = new Date(lastReminder);

      return (
        lastReminderDate.getFullYear() === now.getFullYear() &&
        lastReminderDate.getMonth() === now.getMonth()
      );
    },
  },
  mounted() {
    this.checkShowModal()
    patchProfile({
      last_reminder: new Date(),
    })
  },
  methods: {
    checkShowModal() {
      const hasDismissed = sessionStorage.getItem('onboardingModalDismissed')
      if ((!this.profile.email || !this.profile.phoneNo ) && !this.isLastReminderInCurrentMonth && hasDismissed === null) {
        this.show = true
      }
    },
    closeModal() {
      this.show = false
      sessionStorage.setItem('onboardingModalDismissed', 'true')
    },
    navigateTo() {
      if (!this.profile.email) this.$router.push({ name: 'Add Email' })
      else this.$router.push({ name: 'Add Number' })
    },
    async remindLater() {
      this.closeModal()
      await patchProfile({
        last_reminder: new Date(),
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.mc-modal__reminder {
  position: fixed;
  top: 70px;
  right: 1.5%;
  min-width: 300px;
  max-width: 300px;
  background: white;
  border-radius: 8px;
  box-shadow: 0px 4px 8px rgba(241, 241, 241, 0.2);
  z-index: 150;
  padding: 16px;
}
.mc-outline-none__reminder {
  outline: none !important;
  border: none !important;
}

.mc-pointer__reminder {
  cursor: pointer;
}

.mc-object-cover__reminder {
  object-fit: cover;
}
</style>
